import { CSSObject } from '@chakra-ui/react';

export const TabContainer: CSSObject = {
  borderBottom: '0',
};

export const TabWrapper: CSSObject = {
  gap: '1',
  p: '2',
  bgGradient: 'linear-gradient(to-b, alpha.500, alpha.700)',
  borderRadius: 'md',
};

export const TabOption = ({ isActive }: any): CSSObject => ({
  color: isActive ? 'alpha.200' : 'white',
  textShadow: 'none',
  h: '6',
  fontSize: 'xs',
  px: '3',
  py: '1',
  borderRadius: 'md',
  fontWeight: 'bold',
  textTransform: 'uppercase',
  textDecoration: 'none',
  transition: 'all, 0.2s linear',
  lineHeight: 'tall',
  letterSpacing: 'tight',
  bg: isActive ? 'alpha.800' : 'transparent',
  boxShadow: isActive ? '0px 1px 0px 0px #000 inset' : 'none',

  _hover: {
    bg: 'alpha.800',
  },
  _focus: {
    bg: 'alpha.800',
  },
});
